exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[decktouchanimation] {\n  position: relative; }\n\n[decktouchanimation]::before {\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  border-radius: 50%;\n  content: '';\n  opacity: 0;\n  border: 4px solid rgba(255, 255, 255, 0.5);\n  width: 50px;\n  height: 50px; }\n\n[decktouchanimation].active::before {\n  animation: effect-touch-animation 0.3s ease-out forwards; }\n\n@keyframes effect-touch-animation {\n  0% {\n    opacity: 1;\n    transform: scale3d(0.9, 0.9, 1); }\n  to {\n    opacity: 0;\n    transform: scale3d(1.4, 1.4, 1); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/travis/build/RaphaelYan/ngx-deck/src/touch-animation/touch-animation.directive.scss
// module id = ../../../../../src/touch-animation/touch-animation.directive.scss
// module chunks = main